import React from 'react';
import { getElementStyles } from './elementStyles';
import MapElementBase from './map/MapElementBase';
import GroupElementBase from './group/GroupElementBase';
import StandardElement from './map/StandardElement';
import NoteElement from './map/notes/NoteElement';
import { MAP_ELEMENT_TYPES } from '../../../constants';
import { safeToLower } from '../../../utils/core';

const DragElement = ({ mapElementType, x, y }) => mapElementType.toLowerCase() === MAP_ELEMENT_TYPES.swimlane ||
    mapElementType.toLowerCase() === MAP_ELEMENT_TYPES.group ?
    (
        <GroupElementBase
            height={getElementStyles(mapElementType).groupElement.height}
            width={getElementStyles(mapElementType).groupElement.width}
            developerName={`New ${mapElementType}`}
            elementType={mapElementType}
            x={x}
            y={y}
            borderFill={getElementStyles(mapElementType).border.fill}
            isOpen
        />
    ) :
    (
        <MapElementBase
            component={safeToLower(mapElementType) === MAP_ELEMENT_TYPES.note ? NoteElement : StandardElement}
            styles={getElementStyles(mapElementType)}
            developerName={`New ${mapElementType}`}
            x={x}
            y={y}
        />
    );

export default DragElement;
